export default "__VITE_ASSET__Co472pSN__"